<template>
  <CContainer>
    <h3>Datos de Dependencia y/o Centro Costo</h3>
    <CCard
      class="mt-4 mb-1 p-3 col-sm-12">
      <CCardBody>
          <CForm class="p-2">
              <template v-for="(key) in Object.keys(dependency)">
                    <CCol :key="key" :sm="colSelector(key)"
                      class="d-inline-block">
                        <template v-if="key !== 'ciudad' || key !== 'establecimiento' || key !== 'tipo_Telefono'">
                            <ddi
                            :mkey="key"
                            :label="(key === 'responsable' ? 'Contacto' : replace_(key))+ ': '"
                            :type="key == 'correo_Electronico' ? 'email' : undefined"
                            :value="dependency[key]"
                            @update-data="(value)=>{
                              updateData(value)
                              validate()
                            }"
                            :requiredGroup="group">
                            </ddi>
                        </template>
                        <template v-if="key == 'ciudad'">
                            <CAutocomplete
                              required
                              :options="cities.map(city => {
                                  return {
                                      value: city.id_Ciudad,
                                      label: city.ciudad + ' - ' + city.departamento
                                  }
                              })"
                              :label="replace_(key) + ': '"
                              :value="dependency[key]"
                              @update:input="nvalue => {
                                  dependency[key] = nvalue
                                  validate()
                              }">
                            </CAutocomplete>
                        </template>
                        <template v-if="key == 'establecimiento'">
                            <CAutocomplete
                              :options="places.map(place => {
                                  return {
                                      value: place.id_Establecimiento,
                                      label: place.nombre_Establecimiento
                                  }
                              })"
                              :label="replace_(key)+ ': '"
                              :value="dependency[key]"
                              @update:input="nvalue => {
                                  dependency[key] = nvalue
                                  validate()
                              }">
                            </CAutocomplete>
                        </template>
                        <template v-if="key === 'tipo_Telefono'">
                          <CSelect
                            class=""
                            :value.sync="dependency.tipo_Telefono"
                            :options="[
                              {value: 'G', label: 'General'}, 
                              {value: 'T', label: 'Trabajo'}, 
                              {value: 'M', label: 'Móvil'}, 
                              {value: 'P', label: 'Personal'}, 
                              {value: 'F', label: 'Fax'}
                            ]"
                            label="Tipo Teléfono: "
                            addLabelClasses="text-muted font-weight-bold col-sm-12 px-0" 
                            addInputClasses="col-sm-12"
                            @update:value="(value) => {
                              dependency[key] = value
                            }"
                          />
                        </template>

                        <template v-if="key==='valor_Presupuesto'">

                        </template>

                    </CCol>                
                  </template>
          </CForm>
      </CCardBody>
      <CCardFooter align="center">
          <CButton
            color="primary"
            square 
            class="mr-2 d-inline-block"
            @click="save()"
            :class="isValidForm ? '' : 'disabled'"
            :disabled="!isValidForm">
            <CIcon name="cil-check-alt"/>
            <span class="align-middle mr-2">Guardar</span>
          </CButton>
          <CButton
            color="secondary"
            square 
            class="mr-2 d-inline-block"
            @click="$router.back()">
            <CIcon name="cil-x"/>
            <span class="align-middle mr-2">Cancelar</span>
          </CButton>
      </CCardFooter>
    </CCard>
    <CElementCover  v-show="loading"/>
  </CContainer>
</template>

<script>
  import CONSTANTS from '../../../constants'
  import ddi from '../../containers/DependencyDynamicInput'
  import CAutocomplete from '../../containers/CAutocomplete'
  import { replace_ } from '../../../general'
  import { 
    dataListCiudades,
    dataListEstablecimientos,
    obtenerDependencia,
    guardarDependencia,
    actualizarDependencia
  } from '../../../api'
export default {
  name: 'Dependencies',
  components:{
    ddi,
    CAutocomplete
  },
  data () {
    return {
        create: false,
        cities: [],
        places: [],
        dependencyLoaded: {},
        dependency: {
            "responsable": "",
            "dependencia": "",
            "establecimiento": "",
            "tipo_Telefono": "G",
            "telefono": "",
            "extension": "",
            "direccion": "",
            "ciudad": "",
            "correo_Electronico": "",
            "codigo": "",
            "habilitado_Pedidos": "F",
            "activar_Presupuesto": "F",
            "valor_Presupuesto": 0,
            // "permite_Publicidad_email": null,
            // "permite_Publicidad_sms": null,
            // "permite_Recordatorios_email": null,
            // "permite_Recordatorios_sms": null,
            // "permite_Confirmaciones_email": null,
            // "permite_Confirmaciones_sms": null,
            // "latitud": "0.0000000000000",
            // "longitud": "0.0000000000000",
            // "aceptacion_Habeasdata": null,
            // "aceptacion_Fecha": null,
            // "directorio": "MIGHh3Fc7Gb9Co1Ul2Ao",
            "estado": "A"
        },
        directory: '',
        group: ['responsable', 'dependencia', 'direccion', 'correo_Electronico', 'ciudad', "telefono"],
        isValidForm: false,
        fromRoute: null,
        loading: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fromRoute = from
    })
  },
  methods:{
    async getLists() {        
      try {
        this.loading = true
        const cities = await dataListCiudades(this)
        this.cities = [...cities]
        const places = await dataListEstablecimientos(this, this.directory) 
        this.places = [...places] 
        // this.$store.commit('set', ['cities', [...response]])
      } catch (error) {
        this.$store.commit('setAlert', {
          color: "danger",
          message: 'Error al cargar datos',
          show: 5
        })
        
      } finally {
        this.loading = false
      }
    },
    async getData(id_Dependencia) {
      try {
        this.loading = true
        const response = obtenerDependencia(this, id_Dependencia)
        return response
      } catch (error) {
        this.$store.commit('setAlert', {
          color: "danger",
          message: 'Error al cargar datos',
          show: 5
        })
      } finally {
        this.loading = false
      }
    },
    replace_,
    updateData([key, value]){
      this.dependency[key] = value
    },
    async save(){
      try {
        this.loading = true
        const processData = {...this.dependency}
        Object.keys(processData).forEach(key => {
          processData[key] ? null : delete processData[key]
        })
        processData['directorio'] = this.directory
        if(this.create){
          await guardarDependencia(this, processData)
        } else {          
          await actualizarDependencia(this, this.$store.state['selectedDependency'].id_Dependencia, processData)
        }

        this.$store.commit('setAlert', {
          color: "success",
          message: 'Acción exitosa',
          show: 5
        })
        this.$router.back()
      } catch (error) {
        this.$store.commit('setAlert', {
          color: "danger",
          message: this.create ? CONSTANTS.messages.notDoneAdd : CONSTANTS.messages.notDoneEdit,
          show: 5
        })
      } finally {
        this.loading = true
      }        
    },
    validate() {
        this.isValidForm = this.group.reduce((acc, key) => {
              if (key === "estado") {
                return acc && (this.dependency["estado"] === "A")
              } else {
                return acc && (this.dependency[key].length > 0)
              }
          }, true)
        // console.log(this.isValidForm)
    },
    colSelector(key) {
      if(key==='extension') {
        return 2
      }
      if(key==='telefono') {
        return 4
      }
      return (key==='responsable') || (key==='correo_Electronico')? 12 : 6
    }
  }, 
  async mounted() {
    if(this.$store.state.user.type === 'E') {
      this.directory = this.$store.state['selectedDependency'].id_Directorio
    } else {
      this.directory = this.$store.state.user.data.id_Directorio
    }

    await this.getLists()

    if (!this.$router.currentRoute.fullPath.includes("agregar")) {      
      if (this.$store.state['selectedDependency']) {
        try {
          const dep = await this.getData(this.$store.state['selectedDependency'].id_Dependencia)
          this.dependencyLoaded = {...dep}
          Object.keys(this.dependency).forEach(key => {
              if (this.dependency[key] !== undefined) {
                //   console.log(key, dep[key])
                this.$set(this.dependency, key, dep[key])
                // this.dependency[key] = dep[key]
              }
          })
        } catch(error) {
          this.$store.commit('setAlert', {
          color: "danger",
          message: "Error al cargar datos",
          show: 5
        })
        }
      } else {
        this.$router.back()
      }        
    } else{
      this.create = true
    }
    this.validate()
  }
}
</script>